import { render, staticRenderFns } from "./OrcamentoCabecalho.vue?vue&type=template&id=a46ccc56&scoped=true"
import script from "./OrcamentoCabecalho.vue?vue&type=script&lang=js"
export * from "./OrcamentoCabecalho.vue?vue&type=script&lang=js"
import style0 from "./OrcamentoCabecalho.vue?vue&type=style&index=0&id=a46ccc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46ccc56",
  null
  
)

export default component.exports